import { JsToClientCommand } from '../jsToClientCommand';
import { ClientCommands } from '../clientCommands';

export class SetClientNotificationsBrowserStateHandler extends JsToClientCommand<{}> {
    constructor(params: {isAccessBrowserPush: string}) {
        super(ClientCommands.SET_CLIENT_NOTIFICATIONS_BROWSER_STATE, params);
    }
}
